import ShowUnlinkedModelsSVG from 'assets/lucide-js/unlink.svg?react'
import EditModeSVG from 'assets/pencil.svg?react'
import LabelsEnabledSVG from 'assets/radix-ui/id-card.svg?react'
import { HoverableToggle } from 'components/HoverableToggle'
import { PermissionsGate } from 'features/auth'
import { SiteMapVizEditorPermissionsList } from 'features/siteMapViz'
import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'

import { StyledMapToggle } from './modebarToggles/StyledMapToggle'

const FloatingContainer = styled.div`
  position: absolute;
  top: 2%;
  left: 2%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

interface SiteViewToggleTopOverlayProps {
  showLabels: boolean
  setShowLabels: Dispatch<SetStateAction<boolean>>
  setShowUntaggedModels: Dispatch<SetStateAction<boolean>>
  showUntaggedModels: boolean
  isInEditMode: boolean
  setIsInEditMode: Dispatch<SetStateAction<boolean>>
}
export const SiteViewToggleTopOverlay: FC<SiteViewToggleTopOverlayProps> = (
  props
) => {
  const { showLabels, setShowLabels } = props

  return (
    <FloatingContainer>
      <HoverableToggle
        defaultPressed={showLabels}
        onPressedChange={() => setShowLabels((prev) => !prev)}
        trigger={
          <StyledMapToggle icon={<LabelsEnabledSVG />} enabled={showLabels} />
        }
        content={showLabels ? 'Labels On' : 'Labels Off'}
      />
      <HoverableToggle
        defaultPressed={props.showUntaggedModels}
        onPressedChange={() => props.setShowUntaggedModels((prev) => !prev)}
        trigger={
          <StyledMapToggle
            icon={<ShowUnlinkedModelsSVG />}
            enabled={props.showUntaggedModels}
          />
        }
        content={
          props.showUntaggedModels
            ? 'Displaying Unlinked Models'
            : 'Hiding Unlinked Models'
        }
      />
      <PermissionsGate requires={SiteMapVizEditorPermissionsList}>
        <HoverableToggle
          defaultPressed={props.isInEditMode}
          onPressedChange={() => props.setIsInEditMode((prev) => !prev)}
          trigger={
            <StyledMapToggle
              icon={<EditModeSVG />}
              enabled={props.isInEditMode}
            />
          }
          content={props.isInEditMode ? 'In Edit Mode' : 'Not In Edit Mode'}
        />
      </PermissionsGate>
    </FloatingContainer>
  )
}
